module.exports = __webpack_public_path__ + "static/media/The-Client-Protection-Principles_EN.95e974b3.pdf";